<template>
  <div :class="{error: error}">
    <div class="youtube-search" v-if="!videoIsSelected">
      <div class="youtube-search-inner">
        <section class="library-search-bar">
          <input
            @keyup.enter="sendApiRequest"
            class="library-search-bar-input"
            type="text"
            v-model="searchInput"
            :placeholder="$t('SEARCH_VIDEO')"
            ref="search"
          />
          <button class="search-button" @click.stop="sendApiRequest"/>
        </section>
        <picture>
          <source
            media="(min-width: 781px)"
            srcset="@/assets/images/youtube_logo.png"
          />
          <source
            media="(max-width: 780px)"
            srcset="@/assets/images/fileTypeIcons/youtube.svg"
          />
          <img
            class="youtube-logo"
            src="@/assets/images/fileTypeIcons/youtube.svg"
          />
        </picture>
        <div class="no-results" v-if="noResult">
          <p class="text">{{ $t("NO_RESULTS_EXIST") }}</p>
        </div>
      </div>
      <span class="error-text">{{ $t("ERROR_TEXT") }}</span>
    </div>
    <div class="video" v-else-if="selectedVideo">
      <div class="card">
        <iframe
          :src="selectedVideo.videoURL"
          allowfullscreen
          height="150"
          width="200"
        ></iframe>
        <button @click="toggleVideoIsSelected" class="change-file">
          <img src="@/assets/images/return_arrow_icon.svg" class="return-icon"/>
          <span>{{ $t("CHANGE_VIDEO") }}</span>
        </button>
      </div>
    </div>
    <div class="videos-container" v-if="listDisplay">
      <div :key="index" v-for="(video, index) in videoArray">
        <video-card :video="video" @videoSelected="videoSelected(video)" />
      </div>
    </div>
  </div>
</template>

<script>
import videoCard from '@/components/video-card'
import { apiKey } from '@/constants'
import { mapState } from 'vuex'

export default {
  name: 'youtube-upload-header',
  components: { videoCard },
  data () {
    return {
      key: apiKey,
      searchInput: null,
      videoIsSelected: false,
      noResult: false,
      error: false
    }
  },
  computed: {
    ...mapState({
      selectedEntryOrigin: state => state.collections.selectedEntryOrigin,
      selectedEntry: state => state.collections.selectedEntry,
      videoArray: state => state.youtube.videoArray,
      listDisplay: state => state.youtube.videoListDisplay,
      selectedVideo: state => state.youtube.selectedVideo
    })
  },
  // if we came from 'collectionEntry' then we need to display the video from selected.entry->data->metadata->url
  created () {
    this.$nextTick(function () {
      this.$refs.search.focus()
    })
    if (this.selectedEntryOrigin === 'collectionEntry') {
      this.videoIsSelected = true
      this.$store.dispatch('setSelectedVideo', { videoURL: this.selectedEntry.object.url })
    }
  },

  watch: {
    listDisplay (newVal) {
      if (!newVal) {
        this.noResult = false
      }
    },
    searchInput () {
      if (this.searchInput !== null && this.searchInput === '') {
        this.error = true
      } else {
        this.error = false
      }
    }
  },

  methods: {
    // when enter is press a api request is send with the input search that user enter
    sendApiRequest () {
      this.noResult = false
      // search input wasnt enter
      if (this.searchInput === null || this.searchInput === '') {
        if (this.listDisplay) {
          this.toggleList()
        }
        return
      }
      // this action return an arr with search result
      this.$store.dispatch('searchYoutube', { searchInput: this.searchInput, apiKey: this.key }).then(() => {
        if (!this.videoArray.length) { this.noResult = true }
      })
      this.$store.dispatch('setVideoListDisplay', true)
    },
    // after a video is selected the header change and display the wanted video
    videoSelected (video) {
      this.toggleList()
      this.toggleVideoIsSelected()
      this.$store.dispatch('clearArr')
      this.$store.dispatch('setSelectedVideo', video)
    },
    toggleVideoIsSelected () {
      this.videoIsSelected = !this.videoIsSelected
      this.searchInput = ''
      if (!this.videoIsSelected) {
        this.$store.dispatch('setSelectedVideo', null)
      }
    },
    // toggle search result
    toggleList () {
      this.searchInput = ''
      this.$store.dispatch('setVideoListDisplay', !this.listDisplay)
    }
  }
}
</script>

<style lang="scss" scoped>
.library-search-bar {
  .search-button{
    &:after {
      background-image: url('../assets/images/search_grey_icon.svg');
    }
  }
  &:hover, &:focus, &:focus-within {
    .search-button{
      &:after {
        background-image: url('../assets/images/search_icon.svg');
      }
    }
  }
}
</style>
